<template>
  <v-list-item v-if="item" class="list-item py-3" flat>
    <router-link
      :to="{ name: 'Product', params: { slug: item.product.slug } }"
      class="h-100 w-100 text-decoration-none black--text"
    >
      <v-row
        no-gutters
        class="product pt-0 px-0 align-center white flex-sm-row"
      >
        <v-col cols="12" sm="5" md="4" lg="5" class="product-header ">
          <v-row no-gutters align="center" class="flex-row">
            <img
              class="product-img mr-3"
              :style="{ height: '80px', width: '80px' }"
              :src="item.product.mediaURL"
              :alt="item.product.name"
              onerror="this.onerror=null;this.src='/no-icon.png'"
            />

            <v-list-item-content
              class="col-8 col-sm-8 col-md-7 default--text pa-0"
            >
              <div class="product-name text-body-2">
                {{ item.product.name }}
              </div>
              <div class="font-weight-bold text-uppercasetext-body-2">
                {{ item.product.shortDescr }}
              </div>
              <div class="text-uppercase">
                {{ item.product.description }}
              </div>
            </v-list-item-content>
          </v-row>
        </v-col>
        <v-col class="product-main" cols="12" sm="7" md="6" lg="5">
          <div
            class="product-main-selection d-flex align-center justify-space-between"
          >
            <div class="price-and-promo d-flex align-center">
              <product-promo
                v-if="item.product.warehousePromo"
                :warehousePromo="item.product.warehousePromo"
              />
              <ProductPrice
                v-if="product.priceDisplay"
                :product="item.product"
                :isList="true"
              />
            </div>
            <template v-if="isActive">
              <ProductQty :item="item" :product="item.product" />
            </template>
          </div>
          <!-- <v-row
          no-gutters
          class="product-main-selection align-center justify-end justify-sm-space-between d-flex"
        >
          <v-col cols="3" sm="2" md="2" lg="2">
            <product-promo
              v-if="item.product.warehousePromo"
              :warehousePromo="item.product.warehousePromo"
            />
          </v-col>
          <v-col cols="3" sm="4" md="3" lg="4">
            <ProductPrice :product="item.product" :isList="true" />
          </v-col>
          <v-col
            cols="6"
            sm="6"
            md="7"
            lg="6"
            class="d-flex align-self-stretch pl-sm-0"
          >
            <template v-if="isActive">
              <div
                class="w-100 d-flex align-center justify-end justify-sm-start"
              >
                <ProductQty :item="item" :product="item.product" />
              </div>
            </template>
          </v-col>
        </v-row> -->
        </v-col>
        <v-col
          cols="12"
          md="2"
          class="d-flex flex-column flex-sm-row product-cta-container mt-5 mt-md-0 justify-space-between justify-md-center"
        >
          <template v-if="item.product.available > 0">
            <v-btn
              color="primary"
              class="col-12 col-sm-5 col-lg-2 pa-4 list-buton"
              elevation="0"
              height="45"
              min-width="45"
              @click.stop.prevent="addToCart(quantity)"
              :aria-label="$t('products.addToCart')"
            >
              <v-icon>$cart</v-icon>
              <span class="d-md-none">{{ $t("products.addToCart") }}</span>
            </v-btn>
            <v-btn
              class="col-12 col-sm-5 col-lg-2 pa-4 list-buton"
              elevation="0"
              color="primary"
              height="45"
              min-width="45"
              outlined
              v-on:click.prevent="removeItem()"
              :aria-label="$t('message.removeListitem')"
            >
              <v-icon>$delete</v-icon>
              <span class="d-md-none">{{ $t("message.removeListitem") }}</span>
            </v-btn>
          </template>
          <div
            v-else
            class="text-center mx-auto text-body-1 text-sm-body-2 font-weight-bold"
          >
            <span v-if="!isActive">{{ $t("product.notActive") }}</span>
            <span v-else>{{ $t("product.notAvailable") }}</span>
          </div>
        </v-col>
      </v-row>
    </router-link>
  </v-list-item>
</template>
<style lang="scss">
.list-item {
  border-bottom: 1px solid var(--v-grey-lighten1);
  .product {
    &-header {
      div {
        @media screen and (min-width: 414px) and (max-width: 599px) {
          width: unset;
          margin-top: 0px;
        }
      }
    }
    &-main {
      width: 100%;
    }
    &-cta-container {
      gap: 10px;
      @media screen and (max-width: 414px) {
        width: 100%;
        // margin-top: 25px;
        .v-icon {
          display: none;
        }
      }
    }
  }

  .product-name {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .product-qty .qty-wrap.not-empty .minus {
    background-color: transparent !important;
  }
  .product-qty .qty-wrap.not-empty .plus {
    background-color: transparent !important;
  }
  .list-buton {
    max-height: 45px;
  }
}
</style>
<script>
import ProductPrice from "@/components/product/ProductPrice.vue";
import ProductQty from "@/components/product/ProductQty.vue";
import ProductPromo from "@/components/product/ProductPromo.vue";

import CatalogService from "~/service/catalogService";
import CartService from "~/service/cartService";
import { mapActions } from "vuex";

import productMixin from "~/mixins/product";

export default {
  name: "ListItem",
  components: { ProductPrice, ProductQty, ProductPromo },
  mixins: [productMixin],
  props: ["item", "isActive"],
  computed: {
    product() {
      return this.item.product;
    },
    quantity() {
      // let item = this.item;
      if (this.item === null || this.item.product === null) return 0;
      if (this.item.product.productInfos.TIPOLOGIA == "Sfuso") {
        //Handling floating point decimals issues
        var val = (this.item.weight * 100).toFixed(0);
        val = val * CatalogService.getMultiplier(this.item.product);
        val = val / 100;
        return val;
      } else {
        return this.item.quantity;
      }
    },
    quantityPerUnit() {
      let quantity = this.quantity;
      if (quantity === 0) return;
      if (
        this.item.product.productInfos.TIPOLOGIA === "Sfuso" &&
        this.item.product.productInfos.WEIGHT_SELLING_SINGLE_UNIT
      ) {
        try {
          var singleUnit = Math.floor(
            quantity /
              parseFloat(
                this.item.product.productInfos.WEIGHT_SELLING_SINGLE_UNIT
              )
          );
          var singleUnitUm = this.item.product.productInfos
            .WEIGHT_SELLING_SINGLE_UNIT_UM
            ? this.item.product.productInfos.WEIGHT_SELLING_SINGLE_UNIT_UM
            : "pz";
          return "(" + singleUnit + " " + singleUnitUm + ")";
        } catch (e) {
          console.log(e);
          return;
        }
      }
      if (this.item.product.productInfos.TIPOLOGIA === "Confezione") {
        try {
          let singleUnit =
            quantity *
            parseFloat(this.item.product.productInfos.WEIGHT_SELLING);
          singleUnit = (singleUnit * 1000).toFixed(0);
          singleUnit = singleUnit / 1000;
          let singleUnitUm = this.item.product.productInfos.WEIGHT_UNIT_SELLING;
          return "(" + singleUnit + " " + singleUnitUm + ")";
        } catch (e) {
          console.log(e);
          return;
        }
      }
      return null;
    },
    unit() {
      if (this.item.product.productInfos) {
        if (this.item.product.productInfos.TIPOLOGIA == "Sfuso") {
          return this.item.product.productInfos.WEIGHT_UNIT_SELLING;
        } else {
          return this.item.product.productInfos.UNIT_SELLING != null
            ? this.item.product.productInfos.UNIT_SELLING
            : "pz";
        }
      } else {
        return null;
      }
    }
  },
  methods: {
    ...mapActions({
      addProduct: "cart/addProduct"
    }),
    removeItem() {
      this.$emit("removeItem", {
        itemId: this.item.itemId,
        product: this.item.product
      });
    },
    plus() {
      const newQuantity = CartService.plus(this.item.product, this.quantity);
      this.$emit("update", { newQuantity, item: this.item });
    },
    async minus() {
      const newQuantity = CartService.minus(this.item.product, this.quantity);
      let res = true;
      if (newQuantity <= 0) {
        res = await this.$dialog.confirm({
          text: global.vm.$t("message.removeItemFromList")
        });
      }
      if (res) this.$emit("update", { newQuantity, item: this.item });
    },
    addToCart() {
      this.addProduct({
        product: this.item.product,
        quantity: this.quantity,
        params: { infos: { accept_alternatives: false } },
        searchParams: undefined
      });
    },
    hasPromo(item) {
      return (
        item.product.priceStandardDisplay &&
        item.unitPrice !== item.product.priceStandardDisplay
      );
    }
  }
};
</script>
